export enum TrackingEvents {
  SDK_MODAL_VIEWED = 'sdk_modal_viewed',
  SDK_MODAL_BUTTON_CLICKED = 'sdk_modal_button_clicked',
  SDK_MODAL_TOGGLE_CHANGED = 'sdk_modal_toggle_changed',
}
